/* ============================================================================
 * spa-product.js — APS spa PDP behaviour (ported from pdp-v3.html prototype).
 * ----------------------------------------------------------------------------
 * Kept: gallery thumbnail switching, shell-colour swatch switching, Delivery /
 * Click&Collect tabs, Specs / Dimensions detail tabs, sticky section-nav
 * TABS (2026-07-07: scrollspy replaced with real chapter tabs per client
 * request — #s-* links/hashes activate the matching tab), spec tooltips,
 * expandable sticky mobile bar, reserve deposit modal (+ #reserve deep-link
 * auto-open).
 * Removed (prototype-only): floating accent-colour switcher, postMessage /
 * ?embed / iframe-resize logic, and the story-video player (no videos in
 * theme — "See Videos" is now a plain #gallery anchor; TODO: re-add stories).
 * Accent is permanently locked to brand blue (#1B75BC) in spa.css.
 * ==========================================================================*/
(function () {
  'use strict';

  function init() {
    // Run once even if the script tag is included by more than one section.
    if (window.__apsSpaPdpInit) return;
    window.__apsSpaPdpInit = true;

    var doc = document;

    // ---- gallery: thumbnail → main image ----
    var main = doc.getElementById('mainimg');
    var thumbs = doc.getElementById('thumbs');
    if (main && thumbs) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('.thumb');
        if (!t) return;
        doc.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (t.dataset.src) main.src = t.dataset.src;
      });
    }

    // ---- shell-colour swatches (visual select + main image swap + label + cart variant) ----
    // Each swatch carries data-vid/data-avail (from Liquid); prices are identical across
    // colours per model (verified parity), so only the cart id + availability need syncing.
    // Delegated (2026-07-16): the picker renders twice — under the gallery on mobile and in the
    // buy column on desktop — so bind at document level and sync .active across rows by data-col.
    doc.addEventListener('click', function (e) {
        var s = e.target.closest('.aps-spa .swatch');
        if (!s) return;
        doc.querySelectorAll('.swatch').forEach(function (x) {
          x.classList.toggle('active', x.dataset.col === s.dataset.col);
        });
        if (s.dataset.img && main) main.src = s.dataset.img;
        var stickImg = doc.getElementById('stickimg');
        if (stickImg && s.dataset.img) stickImg.src = s.dataset.img;
        if (s.dataset.col) doc.querySelectorAll('.selcol').forEach(function (el) { el.textContent = s.dataset.col.split(' Shell')[0]; }); /* "Black Opal Shell - Grey Cabinet" -> "Black Opal" */
        if (s.dataset.col) { var qv = s.dataset.col.split(' Shell')[0]; doc.querySelectorAll('.qcolrow input[name="contact[shell_colour]"]').forEach(function (r) { r.checked = (r.value === qv); }); } /* active page choice pre-answers the required form field; untouched default never does */
        if (s.dataset.vid) {
          var avail = s.dataset.avail !== 'false';
          // .aps-spa scope = the buy-box form AND the final-band form; never Dawn quick-add forms
          doc.querySelectorAll('.aps-spa form[action*="/cart/add"]').forEach(function (f) {
            var inp = f.querySelector('input[name="id"]');
            if (inp) inp.value = s.dataset.vid;
            var b = f.querySelector('button[name="add"]');
            if (!b) return;
            b.disabled = !avail;
            b.classList.toggle('soldout', !avail);
            var tx = b.querySelector('.cart-tx');
            var so = b.querySelector('.cart-so');
            if (tx) tx.hidden = !avail;
            if (so) so.hidden = avail;
          });
          // sticky mobile bar CTA mirrors the same availability state
          var stickyBuy = doc.getElementById('stickybuy');
          if (stickyBuy) {
            stickyBuy.classList.toggle('soldout', !avail);
            stickyBuy.textContent = avail ? 'Buy Now' : 'Sold Out';
          }
        }
      });

    // ---- #top scroll CTAs (back-to-top): JS-driven so EVERY tap scrolls.
    //      Bare href="#top" only jumps when the hash CHANGES — the second tap was a dead no-op.
    //      #stickybuy is excluded: it adds to cart (below), href="#top" stays as its no-JS fallback. ----
    doc.addEventListener('click', function (e) {
      var a = e.target.closest('.aps-spa a[href="#top"]');
      if (!a || a.id === 'stickybuy') return;
      e.preventDefault();
      var t = doc.getElementById('top');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // ---- sticky Buy Now = add the SELECTED variant to cart (Aaron 2026-07-17).
    //      The buy-box form's input[name="id"] is already swatch-synced, so submitting it
    //      carts exactly what the shopper picked. Sold out -> scroll to the buy box instead
    //      (reserve CTA lives there). ----
    doc.addEventListener('click', function (e) {
      var b = e.target.closest('#stickybuy');
      if (!b) return;
      e.preventDefault();
      if (b.classList.contains('soldout')) {
        var t = doc.getElementById('top');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var f = doc.querySelector('.aps-spa form[action*="/cart/add"]');
      if (!f) return;
      if (f.requestSubmit) { f.requestSubmit(); } else { f.submit(); }
    });

    // ---- See Videos: inline player (renders only when the product has video media) ----
    (function () {
      var pv = doc.getElementById('playvideo');
      var vid = doc.getElementById('spavideo');
      if (!pv || !vid || !main) return;
      pv.addEventListener('click', function (e) {
        e.preventDefault();
        main.style.display = 'none';
        vid.style.display = 'block';
        try { vid.play(); } catch (err) {}
      });
      // any thumbnail or swatch interaction returns to the image
      doc.addEventListener('click', function (e) {
        if (e.target.closest('.thumb') || e.target.closest('.swatch')) {
          try { vid.pause(); } catch (err) {}
          vid.style.display = 'none';
          main.style.display = '';
        }
      });
    })();

    // ---- delivery / click & collect tabs ----
    var deliv = doc.getElementById('deliv');
    if (deliv) {
      deliv.addEventListener('click', function (e) {
        var t = e.target.closest('.dtab');
        if (!t) return;
        deliv.querySelectorAll('.dtab').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        deliv.querySelectorAll('.dpane').forEach(function (p) {
          p.style.display = p.dataset.pane === t.dataset.d ? '' : 'none';
        });
      });
    }

    // ---- specifications / dimensions detail tabs ----
    var detpanel = doc.getElementById('detpanel');
    if (detpanel) {
      detpanel.addEventListener('click', function (e) {
        var t = e.target.closest('.ptab');
        if (!t) return;
        detpanel.querySelectorAll('.ptab').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        detpanel.querySelectorAll('.ppane').forEach(function (p) {
          p.hidden = p.dataset.pane !== t.dataset.t;
        });
      });
    }

    // ---- sticky section-nav TABS (replaced scrollspy 2026-07-07) ----
    // The secnav is a role="tablist" of buttons; each chapter group is a
    // role="tabpanel" wrapper (.spa-tabpanel). Only the active panel is shown.
    // Any a[href="#s-*"] on the page (e.g. the buy-box rating link → #s-proof)
    // activates the matching tab instead of anchor-scrolling into a hidden
    // panel. #reserve is untouched (handled by the deposit modal below).
    (function () {
      var secnav = doc.getElementById('secnav');
      var bar = secnav && secnav.querySelector('.secnav-in');
      if (!bar) return;
      var tabs = [].slice.call(bar.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function tabFor(key) {
        if (key === 's-included') key = 's-details'; // What's included lives inside the details tab
        for (var i = 0; i < tabs.length; i++) {
          if (tabs[i].dataset.panel === key) return tabs[i];
        }
        return null;
      }

      function updateFade() {
        bar.parentNode.classList.toggle('fade-r', bar.scrollLeft + bar.clientWidth < bar.scrollWidth - 1);
      }

      function activate(tab, scrollToBar) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = doc.getElementById('panel-' + t.dataset.panel);
          if (p) p.hidden = !on;
        });
        // keep the active header visible inside the horizontally-scrollable bar
        var br = bar.getBoundingClientRect();
        var tr = tab.getBoundingClientRect();
        if (tr.left < br.left) bar.scrollLeft += tr.left - br.left - 16;
        else if (tr.right > br.right) bar.scrollLeft += tr.right - br.right + 16;
        updateFade();
        if (scrollToBar) {
          var top = doc.getElementById('spa-tabs-top');
          if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (history.replaceState) history.replaceState(null, '', '#' + tab.dataset.panel);
      }

      bar.addEventListener('click', function (e) {
        var t = e.target.closest('[role="tab"]');
        if (t) activate(t, false);
      });

      // arrow-key support (roving tabindex)
      bar.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(doc.activeElement);
        if (i < 0) return;
        var j = -1;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j < 0) return;
        e.preventDefault();
        activate(tabs[j], false);
        tabs[j].focus();
      });

      // right-edge fade hint while more tab headers remain off-screen (mobile)
      bar.addEventListener('scroll', updateFade, { passive: true });
      window.addEventListener('resize', updateFade);
      updateFade();

      // cross-references: any #s-* chapter link anywhere on the page opens its tab
      doc.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#s-"]');
        if (!a) return;
        var tab = tabFor(a.getAttribute('href').slice(1));
        if (!tab) return;
        e.preventDefault();
        activate(tab, true);
      });

      // deep link on load: /product#s-proof opens the Reviews tab, etc.
      var initial = tabFor(location.hash.slice(1));
      if (initial) activate(initial, true);
    })();

    // ---- spec tooltips (info "i" → modal) ----
    (function () {
      var m = doc.createElement('div');
      m.className = 'tipmodal';
      m.id = 'tipmodal';
      m.innerHTML = '<div class="tipcard"><button class="tipx" id="tipx">&times;</button><div class="tipbody" id="tiptext"></div></div>';
      // append INSIDE an .aps-spa section wrapper (not body) so the scoped .aps-spa .tipmodal
      // styles match — it is position:fixed, so placement in the DOM doesn't affect layout
      (doc.querySelector('.shopify-section.aps-spa') || doc.body).appendChild(m);
      doc.addEventListener('click', function (e) {
        var t = e.target.closest('.tip');
        if (t) {
          doc.getElementById('tiptext').textContent = t.dataset.tip;
          m.classList.add('open');
          return;
        }
        if (e.target.id === 'tipx' || e.target === m) { m.classList.remove('open'); }
      });
    })();

    // ---- expandable sticky mobile bar ----
    (function () {
      var btn = doc.getElementById('stickup');
      var exp = doc.getElementById('stickexp');
      var bar = doc.getElementById('sticky');
      if (btn && exp && bar) {
        btn.addEventListener('click', function () {
          var open = exp.hidden;
          exp.hidden = !open;
          bar.classList.toggle('exp', open);
        });
      }
    })();

    // ---- chat CTAs -> Shopify Inbox widget (2026-07-28, Aaron: chat routes to Inbox, not Messenger)
    // The Inbox V1 widget exposes NO public open API. Its activator lives inside the
    // <inbox-online-store-chat> shadow root, so clicking that button is the only supported
    // trigger. Verified live 2026-07-27: the click adds .chat-app--is-open and flips
    // shopifyChatData.isOpen. The widget mounts async, hence the bounded retry. If it never
    // mounts (app removed, script blocked, ad-blocker) we fall back to the phone so a CTA is
    // never a dead end. NOTE: spa.css must NOT hide #shopify-chat or every CTA here breaks.
    // Shopify is mid-migration from the legacy Inbox widget to the new agent widget (this store
    // flipped 2026-07-29: shopify-inbox-1296 -> 1297, which added #shopify-agent-page-data and
    // switched the bundle selector to agent.js). Support BOTH, newest first, so a rollout or a
    // rollback in either direction cannot break the CTAs.
    function apsOpenChat(attempt) {
      // 1. new agent widget — real public API on the <shopify-chat> element
      var sc = doc.querySelector('shopify-chat');
      if (sc && typeof sc.show === 'function') { try { sc.show(); return; } catch (err) {} }
      // 2. new agent widget — shadow activator (part="activator")
      var act = sc && sc.shadowRoot && sc.shadowRoot.querySelector('button.activator');
      if (act) { act.click(); return; }
      // 3. legacy Inbox V1 widget — shadow toggle
      var host = doc.querySelector('inbox-online-store-chat');
      var toggle = host && host.shadowRoot && host.shadowRoot.querySelector('button.chat-toggle');
      if (toggle) { toggle.click(); return; }
      // 4. still mounting? retry, then fall back to the phone so a CTA is never a dead end
      if ((attempt || 0) < 12) { setTimeout(function () { apsOpenChat((attempt || 0) + 1); }, 250); return; }
      var tel = doc.querySelector('a[href^="tel:"]');
      if (tel) { window.location.href = tel.getAttribute('href'); }
    }

    // Conversion events keep the SAME ref values (placement_handle) so the per-placement,
    // per-product attribution built for the Messenger CTAs survives the channel change.
    // eventID keeps the aps_mc_ prefix for continuity with any server-side CAPI dedup.
    // GA4/GTM: the event is now chat_click (was messenger_click) — repoint anything keyed on
    // the old name.
    doc.addEventListener('click', function (e) {
      var el = e.target.closest('.aps-spa [data-aps-chat]');
      if (!el) return;
      e.preventDefault();
      var ref = el.getAttribute('data-aps-chat') || '';
      var sid;
      try { sid = sessionStorage.getItem('aps_sid') || ('s_anon_' + Date.now()); } catch (err) { sid = 's_anon_' + Date.now(); }
      var eid = 'aps_mc_' + sid + '_' + Date.now();
      var payload = { content_name: 'Chat Click', content_category: ref };
      try {
        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        if (meta && meta.product && meta.product.id) { payload.content_ids = [String(meta.product.id)]; payload.content_type = 'product'; }
      } catch (err) {}
      if (window.fbq) { try { window.fbq('track', 'Contact', payload, { eventID: eid }); } catch (err) {} }
      if (window.gtag) { try { window.gtag('event', 'chat_click', { send_to: 'G-GDJ8QX7WM1', chat_ref: ref, page_path: location.pathname }); } catch (err) {} }
      if (window.dataLayer) { try { window.dataLayer.push({ event: 'chat_click', chat_ref: ref, chat_event_id: eid }); } catch (err) {} }
      apsOpenChat(0);
    });

    // ---- email / phone CTA conversion events (2026-07-16) — same Contact pattern as messenger ----
    doc.addEventListener('click', function (e) {
      var a = e.target.closest('.aps-spa a[href^="mailto:"], .aps-spa a[href^="tel:"]');
      if (!a) return;
      var method = a.getAttribute('href').indexOf('tel:') === 0 ? 'phone' : 'email';
      var ctx = a.dataset.contact || method;
      var sid;
      try { sid = sessionStorage.getItem('aps_sid') || ('s_anon_' + Date.now()); } catch (err) { sid = 's_anon_' + Date.now(); }
      var eid = 'aps_cc_' + sid + '_' + Date.now();
      var label = method === 'phone' ? 'Phone Click' : 'Email Click';
      if (window.fbq) { try { window.fbq('track', 'Contact', { content_name: label, content_category: ctx }, { eventID: eid }); } catch (err) {} }
      if (window.gtag) { try { window.gtag('event', method + '_click', { send_to: 'G-GDJ8QX7WM1', contact_context: ctx, page_path: location.pathname }); } catch (err) {} }
      if (window.dataLayer) { try { window.dataLayer.push({ event: method + '_click', contact_context: ctx, contact_event_id: eid }); } catch (err) {} }
    });

    // ---- form-opener links (sticky bar / final band "Get a quote") ----
    doc.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-quote-open]');
      if (!a) return;
      var qw = doc.getElementById('qwrap');
      if (!qw) return; // fall through to normal #qwrap fragment nav
      e.preventDefault();
      // make sure the Delivery pane (which hosts the form) is the visible tab
      var deliv = doc.getElementById('deliv');
      if (deliv) {
        var delTab = deliv.querySelector('.dtab[data-d="del"]');
        if (delTab && !delTab.classList.contains('active')) delTab.click();
      }
      qw.open = true;
      qw.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = qw.querySelector('input[name="contact[name]"]');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
      if (window.gtag) { try { window.gtag('event', 'quote_form_open', { send_to: 'G-GDJ8QX7WM1', opener: a.textContent.trim(), page_path: location.pathname }); } catch (err) {} }
    });

    // ---- emailed-quote form: postcode -> suburb/state + success lead events (2026-07-16) ----
    (function () {
      var qwrap = doc.getElementById('qwrap');
      if (!qwrap) return;
      var pcInput = doc.getElementById('q-postcode');
      var suburbSel = doc.getElementById('q-suburb');
      var stateInput = doc.getElementById('q-state');
      var pcData = null, pcPromise = null;
      function loadPc() {
        if (!pcPromise) {
          pcPromise = fetch(qwrap.dataset.pc).then(function (r) { return r.json(); }).then(function (d) { pcData = d; return d; }).catch(function () { pcPromise = null; });
        }
        return pcPromise;
      }
      function swapSuburb(tag) {
        // toggles between <select> (known postcode) and free-text <input> (unknown postcode)
        if (!suburbSel || suburbSel.tagName === tag) return suburbSel;
        var el = doc.createElement(tag === 'SELECT' ? 'select' : 'input');
        if (tag === 'INPUT') { el.type = 'text'; el.autocomplete = 'address-level2'; }
        el.name = 'contact[suburb]'; el.id = 'q-suburb';
        suburbSel.parentNode.replaceChild(el, suburbSel);
        suburbSel = el;
        return el;
      }
      function resolve() {
        var pc = (pcInput.value || '').trim();
        if (!/^\d{4}$/.test(pc)) return;
        loadPc().then(function () {
          if (!pcData) { swapSuburb('INPUT'); return; }
          var e = pcData[pc];
          if (!e) { if (stateInput) stateInput.value = ''; swapSuburb('INPUT'); return; }
          if (stateInput) stateInput.value = e.s;
          swapSuburb('SELECT');
          suburbSel.innerHTML = '';
          e.l.forEach(function (s) { var o = doc.createElement('option'); o.value = s; o.textContent = s; suburbSel.appendChild(o); });
          suburbSel.disabled = false;
          suburbSel.required = false;
          if (e.l.length > 1) {
            var p = doc.createElement('option'); p.value = ''; p.textContent = 'Select suburb…'; p.selected = true;
            suburbSel.insertBefore(p, suburbSel.firstChild);
            suburbSel.required = true;
          }
        });
      }
      if (pcInput) {
        pcInput.addEventListener('focus', loadPc, { once: true }); // prefetch on intent
        pcInput.addEventListener('input', resolve);
        resolve(); // browser autofill on load
      }
      // ---- server-side lead capture (aps-capi via api.entangle.com.au/capi) ----
      // The Meta Lead below is browser-only (ad-blocker/ITP fragile) and carries no
      // customer PII. We ALSO capture the submission server-side: fields are stashed at
      // SUBMIT (before Shopify's redirect wipes the form), then POSTed from the SUCCESS
      // page — so only genuinely-submitted forms are recorded, never captcha-blocked or
      // abandoned attempts. The server persists the lead AND fires a Meta CAPI Lead with
      // the SAME event_id (below) + hashed PII, deduped against the browser Lead.
      var APS_LEAD_ENDPOINT = 'https://api.entangle.com.au/capi/aps/pdp-lead';
      function apsCookie(name) {
        try {
          var m = doc.cookie.match('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)');
          return m ? decodeURIComponent(m[1]) : null;
        } catch (err) { return null; }
      }
      function apsFormVal(form, field) {
        try { var el = form.querySelector('[name="contact[' + field + ']"]'); return el ? (el.value || '').trim() : ''; }
        catch (err) { return ''; }
      }
      // Mint a FRESH Lead event_id per submission and store it as the "current" id for
      // this form kind. Both the server CAPI Lead (POSTed on the next page) and the browser
      // fbq Lead read the same stored id, so Meta dedups that pair — while two separate
      // submissions in one session (e.g. quotes on two spas) still get distinct ids.
      // Submit -> redirect -> success is serial (a synchronous Shopify form POST), so the
      // stored id always belongs to the submission whose success page is loading.
      function apsLeadEid(kind) {
        var prefix = kind === 'reserve' ? 'aps_rlead_' : 'aps_flead_', sid;
        try { sid = sessionStorage.getItem('aps_sid') || ('s_anon_' + Date.now()); } catch (err) { sid = 's_anon_' + Date.now(); }
        var id = prefix + sid + '_' + Date.now();
        try { sessionStorage.setItem('aps_lead_eid_' + kind, id); } catch (err) {}
        return id;
      }
      function apsStashLead(form, kind) {
        try {
          var handle = '';
          try { handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0]; } catch (err) {}
          var productField = apsFormVal(form, 'product');
          var payload = {
            form_type: kind,
            event_id: apsLeadEid(kind),
            name: apsFormVal(form, 'name'),
            phone: apsFormVal(form, 'phone'),
            email: apsFormVal(form, 'email'),
            postcode: apsFormVal(form, 'postcode'),
            suburb: apsFormVal(form, 'suburb'),
            state: apsFormVal(form, 'state'),
            product_handle: handle,
            product_title: productField.replace(/\s*\([^)]*\)\s*$/, ''),
            fbp: apsCookie('_fbp'),
            fbc: apsCookie('_fbc'),
            event_source_url: location.href
          };
          sessionStorage.setItem('aps_lead_pending_' + kind, JSON.stringify(payload));
        } catch (err) {}
      }
      function apsPostLead(kind, eventId) {
        try {
          var raw = null;
          try { raw = sessionStorage.getItem('aps_lead_pending_' + kind); } catch (err) {}
          if (!raw) return;
          var payload;
          try { payload = JSON.parse(raw); } catch (err) { return; }
          payload.event_id = eventId; // keep server + browser Lead on the same id (dedup)
          var body = JSON.stringify(payload);
          if (window.fetch) {
            fetch(APS_LEAD_ENDPOINT, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: body, keepalive: true, mode: 'cors', credentials: 'omit'
            }).catch(function () {});
          } else if (navigator.sendBeacon) {
            navigator.sendBeacon(APS_LEAD_ENDPOINT, new Blob([body], { type: 'application/json' }));
          }
          try { sessionStorage.removeItem('aps_lead_pending_' + kind); } catch (err) {}
        } catch (err) {}
      }

      // success state (Shopify redirects back with contact_posted=true): open the form,
      // scroll to it, fire lead events ONCE per session. dataLayer name is deliberately
      // aps_quote_submitted (INERT in GTM) — the container's generate_lead trigger feeds an
      // unverified WooCommerce-era AW account, so Google Ads wiring stays a deliberate step.
      // which form actually posted? the contact_posted flag is SHARED across the page's
      // contact forms, so each form stamps aps_form_kind at submit time (see below).
      if (/contact_posted=true/.test(location.search)) {
        var kind = 'quote';
        try { kind = sessionStorage.getItem('aps_form_kind') || 'quote'; } catch (err) {}
        if (kind === 'reserve') {
          var qokEl = doc.querySelector('#aps-quote-form .qok');
          if (qokEl) qokEl.style.display = 'none'; /* shared flag renders the quote success too — suppress it */
          var rf = doc.getElementById('aps-reserve-form');
          if (rf) rf.style.display = 'none';
          var okEl = doc.getElementById('dep-ok');
          if (okEl) okEl.hidden = false;
          var dmEl = doc.getElementById('depmodal');
          if (dmEl) { dmEl.classList.add('open'); doc.body.style.overflow = 'hidden'; }
          var rguard = 'aps_reserve_lead_' + location.pathname;
          var rfired = false;
          try { rfired = !!sessionStorage.getItem(rguard); } catch (err) {}
          if (!rfired) {
            try { sessionStorage.setItem(rguard, '1'); } catch (err) {}
            var rsid;
            try { rsid = sessionStorage.getItem('aps_sid') || ('s_anon_' + Date.now()); } catch (err) { rsid = 's_anon_' + Date.now(); }
            var reid = null;
            try { reid = sessionStorage.getItem('aps_lead_eid_reserve'); } catch (err) {}
            if (!reid) reid = 'aps_rlead_' + rsid + '_' + Date.now();
            if (window.fbq) { try { window.fbq('track', 'Lead', { content_name: 'Reservation request', content_category: 'reserve_deposit_form' }, { eventID: reid }); } catch (err) {} }
            if (window.gtag) { try { window.gtag('event', 'generate_lead', { send_to: 'G-GDJ8QX7WM1', form_id: 'aps_spa_reserve', page_path: location.pathname }); } catch (err) {} }
            if (window.dataLayer) { try { window.dataLayer.push({ event: 'aps_reserve_submitted', form_id: 'aps_spa_reserve', lead_event_id: reid }); } catch (err) {} }
            apsPostLead('reserve', reid); // server-side capture + Meta CAPI Lead (same event_id)
          }
        } else {
          qwrap.open = true;
          setTimeout(function () { qwrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
          var guard = 'aps_quote_lead_' + location.pathname;
          var fired = false;
          try { fired = !!sessionStorage.getItem(guard); } catch (err) {}
          if (!fired) {
            try { sessionStorage.setItem(guard, '1'); } catch (err) {}
            var sid;
            try { sid = sessionStorage.getItem('aps_sid') || ('s_anon_' + Date.now()); } catch (err) { sid = 's_anon_' + Date.now(); }
            var eid = null;
            try { eid = sessionStorage.getItem('aps_lead_eid_quote'); } catch (err) {}
            if (!eid) eid = 'aps_flead_' + sid + '_' + Date.now();
            if (window.fbq) { try { window.fbq('track', 'Lead', { content_name: 'Emailed quote request', content_category: 'delivery_quote_form' }, { eventID: eid }); } catch (err) {} }
            if (window.gtag) { try { window.gtag('event', 'generate_lead', { send_to: 'G-GDJ8QX7WM1', form_id: 'aps_spa_quote', page_path: location.pathname }); } catch (err) {} }
            if (window.dataLayer) { try { window.dataLayer.push({ event: 'aps_quote_submitted', form_id: 'aps_spa_quote', lead_event_id: eid }); } catch (err) {} }
            apsPostLead('quote', eid); // server-side capture + Meta CAPI Lead (same event_id)
          }
        }
      }

      // form-identity markers (fire on every submit attempt, incl. the captcha-guard retry)
      var rform = doc.getElementById('aps-reserve-form');
      if (rform) {
        rform.addEventListener('submit', function () {
          try { sessionStorage.setItem('aps_form_kind', 'reserve'); } catch (err) {}
          var shell = doc.getElementById('dep-shell');
          var sc2 = doc.querySelector('.selcol');
          if (shell && sc2) shell.value = sc2.textContent.trim();
          apsStashLead(rform, 'reserve'); // capture fields now; POST happens on success page
        });
      }
      var qformEl = doc.getElementById('aps-quote-form');
      if (qformEl) {
        qformEl.addEventListener('submit', function () {
          try { sessionStorage.setItem('aps_form_kind', 'quote'); } catch (err) {}
          apsStashLead(qformEl, 'quote'); // capture fields now; POST happens on success page
        });
      }
    })();

    // ---- reserve-deposit modal (+ #reserve deep-link auto-open) ----
    (function () {
      var dm = doc.getElementById('depmodal');
      var open = doc.getElementById('openDeposit');
      if (!dm || !open) return;
      open.addEventListener('click', function () {
        var sc = doc.querySelector('.selcol');
        var depCol = doc.getElementById('dep-col');
        if (sc && depCol) depCol.textContent = sc.textContent + (depCol.dataset.sub || '');
        var act = doc.querySelector('.swatch.active');
        var depImg = doc.getElementById('dep-img');
        if (act && depImg && act.dataset.img) depImg.src = act.dataset.img;
        dm.classList.add('open');
        doc.body.style.overflow = 'hidden';
      });
      dm.addEventListener('click', function (e) {
        if (e.target === dm || e.target.id === 'depx') {
          dm.classList.remove('open');
          doc.body.style.overflow = '';
        }
      });
      if (location.hash === '#reserve') open.click();
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
